<template>
    <div class="right-content">
        <div class="right-content-body">
            <div class="title">
                什么是白色污染
            </div>
            <div class="content">
                <p class="bold">什么是白色污染</p>
                <p class="indent">白色污染是我国城市特有的环境污染，在各种公共场所到处都能看见大量废弃的塑料制品，他们从自然界而来，由人类制造，最终归结于大自然时却不易被自然所消纳，从而影响了大自然的生态环境。从节约资源的角度出发，由于塑料制品主要来源是面临枯竭的石油资源，应尽可能回收，但由于现阶段再回收的生产成本远高于直接生产成本，在现行市场经济条件下难以做到。面对日益严重的白色污染问题，人们希望寻找一种能替代现行塑料性能,又不造成白色污染的塑料替代品,可降解塑料应运而生，这种新型功能的塑料，其特点是在达到一定使用寿命废弃后，在特定的环境条件下，由于其化学结构发生明显变化，引起某些性能损失及外观变化而发生降解，对自然环境无害或少害。例如淀粉填充塑料，首先其所含淀粉在短时间内被土壤中的微生物分泌的淀粉酶迅速分解而生成空洞，导致薄膜力学性能下降，同时配方中添加的自氧剂与土壤中的金属盐反应生成过氧化物，使聚乙烯的链断裂而降解成易被微生物吞噬的小碎片被自然环境所消纳，同时起到改良土壤的作用。</p>
                <p class="indent">塑料最早运用于农业地膜，给农业生产带来了极大的发展，可使农作物在任何季节生长，促进了市场消费。据市场统计，自1990～1995年，塑料的生产以每年8．9％的速度增长，已经席卷了整个地球。简直可以称作“白色革命”。但它在为人们提供方便的同时，也给人们带来了一场“白色灾难”。</p>
                <p class="bold">来源</p>
                <p class="indent">白色污染是我国城市特有的环境污染，在各种公共场所到处都能看见大量废弃的塑料制品，他们从自然界而来，由人类制造，最终归结于大自然时却不易被自然所消纳，从而影响了大自然的生态环境。从节约资源的角度出发，由于塑料制品主要来源是面临枯竭的石油资源，应尽可能回收，但由于现阶段再回收的生产成本远高于直接生产成本，在现行市场经济条件下难以做到。面对日益严重的白色污染问题，人们希望寻找一种能替代现行塑料性能,又不造成白色污染的塑料替代品,可降解塑料应运而生，这种新型功能的塑料，其特点是在达到一定使用寿命废弃后，在特定的环境条件下，由于其化学结构发生明显变化，引起某些性能损失及外观变化而发生降解，对自然环境无害或少害。例如淀粉填充塑料，首先其所含淀粉在短时间内被土壤中的微生物分泌的淀粉酶迅速分解而生成空洞，导致薄膜力学性能下降，同时配方中添加的自氧剂与土壤中的金属盐反应生成过氧化物，使聚乙烯的链断裂而降解成易被微生物吞噬的小碎片被自然环境所消纳，同时起到改良土壤的作用。</p>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "InitiativeView"
    }
</script>

<style lang="scss" scoped>
    .right-content {
        padding: 30px;
        margin-left: 130px;
        font-size: 13px;
        .right-content-body {
            max-height: 620px;
            overflow-y: auto;
            overflow-x: hidden;
            .title {
                -webkit-text-stroke: 0.05em #33c;
                -webkit-text-fill-color : transparent;
                font-size: 30px;
                text-shadow: 3px 3px 2px #b2b2b2;
                text-align: left;
                font-family: SimSun;
            }
        }
    }
</style>